import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=68791762&scoped=true"
import script from "./chart.vue?vue&type=script&lang=js"
export * from "./chart.vue?vue&type=script&lang=js"
import style0 from "./chart.vue?vue&type=style&index=0&id=68791762&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68791762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68791762')) {
      api.createRecord('68791762', component.options)
    } else {
      api.reload('68791762', component.options)
    }
    module.hot.accept("./chart.vue?vue&type=template&id=68791762&scoped=true", function () {
      api.rerender('68791762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/chart.vue"
export default component.exports